import React from 'react';
import {View, Text} from '../../react-core-components';
class LeftLabel extends React.Component {
  render() {
    let {
      label,
      labelContainerStyle,
      labelStyle,
      mandatory,
      mandatoryStyle,
      children,
    } = this.props;
    if (label === false) {
      return children;
    }
    return (
      <View style={{flexDirection: 'row'}}>
        <View style={{flexDirection: 'row', ...labelContainerStyle}}>
          {label ? <Text style={labelStyle}>{label}</Text> : void 0}
          {label && mandatory ? (
            <Text style={mandatoryStyle || labelStyle}>*</Text>
          ) : (
            void 0
          )}
        </View>
        <View style={{flex: 1, overflow: 'hidden'}}>
          {React.cloneElement(children, {
            label: void 0,
            mandatory: void 0,
          })}
        </View>
      </View>
    );
  }
}

LeftLabel.defaultProps = {
  labelContainerStyle: {
    height: 44,
    width: 100,
    alignItems: 'center',
    paddingRight: 6,
  },
  labelStyle: {
    fontSize: 14,
    // color: '#8E8E8E',
    numberOfLines: 1,
  },
};

export default LeftLabel;
